import { cva, type VariantProps } from "class-variance-authority";

export { default as Button } from "./Button.vue";

export const buttonVariants = cva(
  "inline-flex outline-none rounded-[8px] items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-all duration-200 ease-in-out focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground disabled:bg-custom-gray-400 disabled:text-custom-gray-200 focus-visible:ring-0 focus-visible:shadow-[0px_0px_0px_1px_rgba(157,209,131,1)] focus:shadow-[0px_0px_0px_1px_rgba(157,209,131,1)] hover:text-custom-gray-100 hover:bg-[linear-gradient(105.08deg,_#2EA381_21.23%,_#D2E783_125.55%)]",
        light:
          "bg-custom-gray-100 text-custom-gray-300 hover:bg-customg-gray-25 hover:text-custom-gray-800 disabled:bg-custom-gray-200 disabled:text-custom-gray-300 ",

        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline:
          "text-custom-gray-150 border border-custom-gray-500 bg-custom-gray-700 hover:bg-custom-gray-500 hover:text-accent-foreground focus:shadow-[0_0_10px_0_rgba(157,209,131,0.25)] focus:outline-none",
        secondary:
          "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:text-accent-foreground text-custom-gray-150",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        xs: "h-7 px-2",
        sm: "h-8 px-3 text-xs",
        lg: "h-10 px-8",
        icon: "h-9 w-9 rounded-full",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

export type ButtonVariants = VariantProps<typeof buttonVariants>;
